"use strict";

exports.__esModule = true;
exports.UsersToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _System = require("../../../System");
var _Core = require("../../Core");
var _UserListContext = require("../UserListContext");
var _getFilteredUserList = require("../getFilteredUserList");
var _reactCsv = require("react-csv");
var _Role = require("../../Role");
var _PlantListContext = require("../../Plant/PlantListContext");
var _dec, _dec2, _dec3, _class, _UsersToolbar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var UsersToolbar = exports.UsersToolbar = (_dec = _UserListContext.UserListContext.withContext, _dec2 = _Role.RoleListContext.withContext, _dec3 = _PlantListContext.PlantListContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_UsersToolbar = /*#__PURE__*/function (_Component) {
  function UsersToolbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(UsersToolbar, _Component);
  var _proto = UsersToolbar.prototype;
  _proto.onCSVExport = function onCSVExport() {
    var result = [["First Name", "Last Name", "Username", "Email address", "Enabled", "Plants", "Roles"]];
    var users = this.props.users.userList;
    var roles = this.props.roles;
    var plants = this.props.plantList;
    users.forEach(function (user) {
      var _user$profile, _user$profile2, _user$profile3;
      result.push([(_user$profile = user.profile) != null && (_user$profile = _user$profile.name) != null && _user$profile.first ? user.profile.name.first : "", (_user$profile2 = user.profile) != null && (_user$profile2 = _user$profile2.name) != null && _user$profile2.last ? user.profile.name.last : "", user.username, (_user$profile3 = user.profile) != null && _user$profile3.email ? user.profile.email : "", user.isEnabled, user.plants.map(function (plant) {
        var foundPlant = plants.find(function (it) {
          return it.id === plant;
        });
        return foundPlant ? foundPlant.name : "";
      }), user.roles.map(function (role) {
        var foundRole = roles.find(function (it) {
          return it.id === role;
        });
        return foundRole ? foundRole.name : "";
      })]);
    });
    return result;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      users = _this$props.users,
      showCreateButton = _this$props.showCreateButton;
    var filteredUsers = (0, _getFilteredUserList.getFilteredUserList)(users);
    var userCount = filteredUsers.length;
    return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
      onChange: users.onFilterChange,
      value: users.filterValue
    }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      minimal: true,
      style: {
        marginLeft: "1rem"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      active: users.showEnabled,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "enabled",
        defaultMessage: "Enabled"
      }),
      onClick: users.handleEnableClick
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      active: !users.showEnabled,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "disabled",
        defaultMessage: "Disabled"
      }),
      onClick: users.handleDisableClick
    })), /*#__PURE__*/_react["default"].createElement(_Core.ToolbarDescription, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UsersToolbar.userCount",
      defaultMessage: "\n              {value} {userCount, plural,\n                one {user}\n                other {users}\n              }\n            ",
      values: {
        value: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
          value: userCount
        })),
        userCount: userCount
      }
    })), /*#__PURE__*/_react["default"].createElement(_reactCsv.CSVLink, {
      data: this.onCSVExport(),
      filename: "users.csv"
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      icon: "download",
      style: {
        marginLeft: "10px"
      }
    }, "Download"))), showCreateButton && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      style: {
        marginLeft: "auto"
      },
      intent: _core.Intent.PRIMARY,
      icon: _icons.IconNames.ADD,
      to: (0, _System.getScreenURL)("CreateUser"),
      "data-testid": "UsersToolbar.createUserButton"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UsersToolbar.createUserButton.text",
      defaultMessage: "Create User"
    })));
  };
  return UsersToolbar;
}(_react.Component), _UsersToolbar.defaultProps = {
  showCreateButton: true,
  users: undefined,
  roles: undefined,
  plantList: undefined
}, _UsersToolbar)) || _class) || _class) || _class);